<script setup lang="ts">
import {ref} from 'vue'
import {useGlobalStore} from '../stores/global'
import {getEnvironment} from '../utils/getEnvironment'
import {version as currentVersion} from '../../package.json'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

const globalStore = useGlobalStore()
const isNewUiEnabled = useNewUiEnabled()

const version = ref(`RateBoard ${currentVersion}`)
</script>

<template>
  <footer
    class="w-full text-white text-base py-8"
    :class="{
      'px-10 md:px-20': !isNewUiEnabled,
      'px-new-lg sm:px-new-5xl md:px-20': isNewUiEnabled,
      'bg-branddark': !globalStore.isSuperAdmin,
      'bg-red': globalStore.isSuperAdmin && getEnvironment() === 'production',
      'bg-devgreen': globalStore.isSuperAdmin && getEnvironment() === 'development',
      'bg-stagingblue': globalStore.isSuperAdmin && getEnvironment() === 'staging',
      'bg-localgrey': globalStore.isSuperAdmin && getEnvironment() === 'localhost',
    }"
  >
    <div class="w-full" :class="{'max-w-screen-new-lg mx-auto': isNewUiEnabled}">
      <div class="flex flex-wrap gap-4 sm:flex-row sm:space-y-0" :class="{'gap-new-xl': isNewUiEnabled}">
        <div class="w-full px-1.5 sm:w-1/4">
          <h2 class="mb-2 text-lg font-bold sm:mb-4">{{ $t('footer.support.title') }}</h2>
          <p>
            {{ $t('footer.support.times1') }}
            <br />
            {{ $t('footer.support.times2') }}
          </p>
        </div>

        <div class="w-full px-1.5 sm:w-1/4">
          <h2 class="mb-2 text-lg font-bold sm:mb-4">{{ $t('footer.contact.title') }}</h2>
          <p>
            <a class="text-white hover:text-brandmain" href="mailto:support@rateboard.io">support@rateboard.io</a>
          </p>
        </div>

        <div
          class="w-full px-1.5 sm:w-1/4 sm:text-center"
          :class="{'sm:order-first': !isNewUiEnabled, 'order-first': isNewUiEnabled}"
        >
          <div class="w-fit">
            <img v-tt="version" alt="RateBoard" class="w-12 mx-auto sm:w-10" src="/logo_mini_white.svg" />
            <a class="before:content-['\00a9'] text-white hover:text-brandmain" href="https://www.rateboard.io">RateBoard GmbH </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
